import React from 'react';
import { useRecordContext } from 'react-admin';
import DescriptionIcon from '@mui/icons-material/Description';

import IconButton from '../../common/buttons/IconButton';

import { API_URL } from '../../../services/settings';

const DownloadUBLButton = () => {
    const record = useRecordContext();

    return (
        <IconButton
            icon={<DescriptionIcon />}
            component="a"
            target="__blank"
            href={`${API_URL}/invoices/${record?.id}/ubl.xml`}
        >
            UBL
        </IconButton>
    );
};

export default DownloadUBLButton;
